<template>
  <div
    v-if="venue"
    class="container"
  >
    <Toolbar class="mt-2 mb-2">
      <template #start>
        <h2>{{ $t('venueDetailPage.title') }}</h2>
      </template>

      <template #end>
        <Button
          :label="$t('action.back')"
          icon="pi pi-arrow-left"
          class="p-button-secondary p-button-rounded p-button-outlined"
          @click="toVenueTable"
        />
      </template>
    </Toolbar>

    <!-- Informations -->
    <Panel class="mb-3">
      <template #header>
        <p class="font-bold">
          {{ $t('venueDetailPage.venue') }}
        </p>
      </template>
      <div class="card_details ">
        <div class="card_body">
          <ul class="flex justify-content-between">
            <li>
              <ul>
                <li class="overflow-hidden text-overflow-ellipsis">{{ $t('entity.venue.code') }} : <strong>{{ venue.code }}</strong></li>
                <li class="overflow-hidden text-overflow-ellipsis">{{ $t('entity.venue.frenchWording') }} : <strong>{{ venue.frenchWording }}</strong></li>
                <li class="overflow-hidden text-overflow-ellipsis">{{ $t('entity.venue.englishWording') }} : <strong>{{ venue.englishWording }}</strong></li>
              </ul>
            </li>
            <li>
              <ul>
                <li class="overflow-hidden text-overflow-ellipsis">{{ $t('entity.venue.address') }} : <strong>{{ venue.address.name }} {{ venue.address.postcode }} {{ venue.address.city }}</strong></li>
                <li class="overflow-hidden text-overflow-ellipsis">{{ $t('entity.venue.timeZone') }} : <strong>{{ venue.timeZone }}</strong></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
import Panel from "primevue/panel";
import Button from "primevue/button";
import Toolbar from "primevue/toolbar";

export default {
  name: 'VenueDetail',
  components: {Toolbar, Panel, Button },
  data() {
    return {
      venue: null
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  },
  async mounted() {
    try {
      this.venue = await this.$venueService.fetchVenue(this.id);
      if (!this.venue) await this.$router.push("/venue")
    } catch (e) {
      this.$emitter.emit('toast', {
        severity: 'error',
        message: e.response.data.map(error => this.$t(error)).join(', ')
      });
      await this.$router.push("/venue")
    }
  },
  methods: {
    toVenueTable() {
      this.$router.push({ name: 'venue' })
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  float: right;
}

.card_details {
  span {
    float: none;
  }

  ul,
  ol {
    list-style: none;
    padding: 0;
  }

  .card_header {
    .card_times {
      background: #f7f7f7;
      padding: 10px;
      font-weight: 600;
    }
  }

  .card_body {
    li {
      width: 25vw;
      padding: 5px 0;
    }

  }
}

::v-deep(div.p-panel-header) {
  padding: 0 1rem;
}

::v-deep(div.p-panel-content) {
  padding: 0.1rem 1rem;
}
</style>
